/* ---------------------------------------------------------------------------
   Le Philtre — défilement automatique des carrousels à scroll horizontal
   (Prestige <scroll-carousel> / <multi-column> en .scroll-area), carte par
   carte, jusqu'à la PREMIÈRE interaction de l'internaute (toucher, glisser,
   molette, clavier, flèches). Activé par l'attribut data-lp-autoplay="<s>"
   posé par les sections (réglage « Défilement automatique »).

   Volontairement indépendant de l'API interne de ScrollCarousel (theme.js) :
   on ne lit que le DOM et scrollTo(), pour rester compatible avec les
   mises à jour Prestige. Inactif dans l'éditeur de thème et avec
   prefers-reduced-motion.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var INTERACTION_EVENTS = ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'];
  var MIN_DELAY = 2;
  var DEFAULT_DELAY = 4;

  function setup(el) {
    if (el.__lpAutoplay) return;
    el.__lpAutoplay = true;

    var seconds = parseFloat(el.getAttribute('data-lp-autoplay'));
    if (isNaN(seconds)) seconds = DEFAULT_DELAY;
    var delay = Math.max(MIN_DELAY, seconds) * 1000;

    var timer = null;
    var stopped = false;
    var visible = false;

    function cells() {
      return Array.prototype.filter.call(el.children, function (c) {
        return !c.hidden && c.offsetWidth > 0;
      });
    }

    function isScrollable() {
      return el.scrollWidth - el.clientWidth > 1;
    }

    /* Position de scroll qui aligne une carte (même logique que Prestige :
       scroll-snap-align start/center + scroll-padding). */
    function targetFor(item, align, pad) {
      var elRect = el.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var left = itemRect.left - elRect.left + el.scrollLeft;
      if (align === 'center') {
        return Math.round(left + itemRect.width / 2 - el.clientWidth / 2);
      }
      return Math.round(left - pad);
    }

    function step() {
      if (stopped || !visible || document.hidden || !isScrollable()) return;
      var items = cells();
      if (items.length < 2) return;

      var style = getComputedStyle(el);
      var pad = parseInt(style.scrollPaddingInlineStart, 10) || 0;
      var align = getComputedStyle(items[0]).scrollSnapAlign;
      align = align === 'center' ? 'center' : 'start';

      var current = el.scrollLeft;
      var maxLeft = el.scrollWidth - el.clientWidth;
      var next = null;

      for (var i = 0; i < items.length; i++) {
        var t = targetFor(items[i], align, pad);
        if (t > current + 2) { next = t; break; }
      }

      if (next === null || current >= maxLeft - 2) {
        next = 0; /* dernière carte atteinte : retour au début */
      } else {
        next = Math.min(next, maxLeft);
      }

      el.scrollTo({ left: next, behavior: 'smooth' });
    }

    function clear() {
      if (timer) { clearTimeout(timer); timer = null; }
    }

    function schedule() {
      clear();
      if (stopped || !visible || document.hidden) return;
      timer = setTimeout(function () { step(); schedule(); }, delay);
    }

    function stop() {
      if (stopped) return;
      stopped = true;
      clear();
      el.removeAttribute('data-lp-autoplay');
      el.setAttribute('data-lp-autoplay-stopped', '');
    }

    INTERACTION_EVENTS.forEach(function (name) {
      el.addEventListener(name, stop, { passive: true });
    });

    /* Flèches / navigation Prestige qui pilotent ce carrousel. */
    if (el.id) {
      Array.prototype.forEach.call(document.querySelectorAll('[aria-controls="' + el.id + '"]'), function (ctrl) {
        ctrl.addEventListener('click', stop, { passive: true });
        ctrl.addEventListener('pointerdown', stop, { passive: true });
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries.some(function (e) { return e.isIntersecting; });
        schedule();
      }, { threshold: 0.4 }).observe(el);
    } else {
      visible = true;
      schedule();
    }

    document.addEventListener('visibilitychange', schedule);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('[data-lp-autoplay]')) setup(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-lp-autoplay]'), setup);
  }

  function init() {
    scan(document);
    /* Sections chargées après coup (ex. recommandations produit via fetch). */
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          Array.prototype.forEach.call(m.addedNodes, function (n) {
            if (n.nodeType === 1) scan(n);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
